import { createBrowserRouter } from 'react-router-dom'
import { wmsCargoRoutes } from './wmscargo.routes'
import { wmsContainers } from './wmscontainers.routes'

// Файл содержит описание всех роутеров для работы в приложении.

const routes = wmsCargoRoutes.concat(wmsContainers)

export const actionBrowser = createBrowserRouter(routes)
